module.exports = __webpack_public_path__ + "img/15.c6340494.jpg";